import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuranPlayer } from '../../contexts/QuranPlayerContext';
import QuranAudioBar from './QuranAudioBar';

/**
 * Persistent mini audio bar rendered app-wide (outside the Surah reader) so
 * recitation keeps playing and stays controllable while browsing other pages.
 */
const GlobalQuranBar = () => {
  const { player, chapter, reciterId } = useQuranPlayer();
  const navigate = useNavigate();
  return (
    <QuranAudioBar
      player={player}
      chapterName={chapter?.name_simple || ''}
      reciterId={reciterId}
      onVerseClick={() => chapter && navigate(`/quran/surah/${chapter.id}`)}
    />
  );
};

export default GlobalQuranBar;
